<template lang="html">
  <section class="market-storyteller">
    <div class="container">
      <h1 class="mb-2 mt-5 pt-5 ms-5">Our top rated Storyteller this week</h1>
      <div class="">
        <MarketPlaceStorytellerCarousel />
      </div>
    </div>
  </section>
</template>

<script lang="js">

import { useStore } from 'vuex';
import { ref, computed } from 'vue';
import MarketPlaceStorytellerCarousel from '@/components/partials/MarketPlaceStorytellerCarousel.vue';

export default {
  name: 'MarketplaceStoryteller',
  props: [],
  components: {
    MarketPlaceStorytellerCarousel,
  },
  setup() {
    return {
    };
  },
  mounted() {

  },
  data() {
    return {

    };
  },
  methods: {

  },
  computed: {

  },
};
</script>

<style scoped lang="scss"></style>
